export const emailSac = 'mailto:sac@medprevonline.com';

export const phoneProfessionalSac = '41 3003-5153';

export const phonePatientSac = '8006727250';
